import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import UserAvatar from "../../../images/user.png";
import {
  BASE_URL_MEDIA,
  BASE_URL_COMPETITION,
  IS_CORPORATE,
  BASE_URL_METABUDDY,
} from "../../../api/Constants";
import UserDropdownMenu from "./UserDropdownMenu";
import { getImageUrl } from 'components/helpers/Helpers';

/**
 * Mobile Navigation Component
 * Renders the navigation menu for mobile viewports with collapsible menus
 */
const MobileNav = ({
  menuItems,
  activePage,
  metaToken,
  userProfile,
  userEmail,
  isActive,
  showUserMenu,
  toggleNav,
  toggleUserMenu,
  LogOut,
  checkCurrentPageUrl,
  logo,
}) => {
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const navigate = useNavigate();

  const toggleSubmenu = (index) => {
    setActiveSubmenu(activeSubmenu === index ? null : index);
  };

  return (
    <>
      <div className="mobile-header">
        <div className="logo">
          <a href={IS_CORPORATE ? BASE_URL_COMPETITION : BASE_URL_METABUDDY}>
            <img src={logo} alt="Logo" />
          </a>
        </div>

        <div className="mobile-header-right">
          <div
            className={`hamburger ${isActive ? "hamburger-active" : ""}`}
            onClick={toggleNav}
          >
            <span className="line" style={{ background: "black" }}></span>
            <span className="line" style={{ background: "black" }}></span>
            <span className="line" style={{ background: "black" }}></span>
          </div>
        </div>
      </div>

      <div className={`mobile-menu ${isActive ? "show-mobile-menu" : ""}`}>
        {metaToken && (
          <div className="mobile-user-info">
            <div className="mobile-user-profile-row">
              <div className="mobile-user-avatar">
                {userProfile ? (
                  <img
                  src={
                    !userProfile || userProfile === 'null'
                      ? `${UserAvatar}`
                      : getImageUrl(userProfile, BASE_URL_MEDIA)
                  }
                    alt=""
                  />
                ) : (
                  <img src={UserAvatar} alt="" />
                )}
              </div>
              <div className="mobile-user-details">
                <div className="mobile-user-email">{userEmail}</div>
                <div className="mobile-user-dropdown" onClick={toggleUserMenu}>
                  <span
                    className={`dropdown-arrow ${showUserMenu ? "active" : ""}`}
                  ></span>
                </div>
              </div>
            </div>

            {showUserMenu && (
              <UserDropdownMenu
                toggleUserMenu={toggleUserMenu}
                LogOut={LogOut}
                checkCurrentPageUrl={checkCurrentPageUrl}
              />
            )}
          </div>
        )}

        <ul className="mobile-nav-list">
          {menuItems.map((item, index) => {
            const hasSubmenu = item.submenu && item.submenu.length > 0;

            return (
              <li
                key={`mobile-${index}`}
                className={`${activePage === item.path ? "active-page" : ""} ${
                  hasSubmenu ? "has-submenu" : ""
                }`}
              >
                {item.isExternal ? (
                  <a
                    href={item.path}
                    onClick={() => !hasSubmenu && toggleNav()}
                  >
                    {item.label}
                    {hasSubmenu && (
                      <span
                        className={`submenu-arrow ${
                          activeSubmenu === index ? "active" : ""
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          toggleSubmenu(index);
                        }}
                      ></span>
                    )}
                  </a>
                ) : (
                  <>
                    <Link
                      to={item.path}
                      onClick={() => {
                        if (!hasSubmenu) {
                          navigate(item.path, { replace: true });
                        }
                      }}
                    >
                      {item.label}
                    </Link>
                    {hasSubmenu && (
                      <span
                        className={`submenu-arrow ${
                          activeSubmenu === index ? "active" : ""
                        }`}
                        onClick={() => toggleSubmenu(index)}
                      ></span>
                    )}
                  </>
                )}
                {hasSubmenu && activeSubmenu === index && (
                  <ul className="mobile-submenu">
                    {item.submenu.map((subItem, subIndex) => (
                      <li key={`submenu-${index}-${subIndex}`}>
                        <Link
                          to={subItem.path}
                          onClick={() => {
                            navigate(subItem.path, { replace: true });
                          }}
                        >
                          {subItem.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            );
          })}

          {!metaToken && (
            <>
              <li className="mobile-login-item">
                <Link
                  to="/login"
                  onClick={() => {
                    checkCurrentPageUrl();
                  }}
                >
                  Login
                </Link>
              </li>
              <li className="mobile-register-item">
                <Link
                  to="/register"
                  onClick={() => {
                    checkCurrentPageUrl();
                  }}
                >
                  Register
                </Link>
              </li>
            </>
          )}
        </ul>
      </div>
    </>
  );
};

export default MobileNav;
